
import { Component, Prop, Vue } from "vue-property-decorator";
import RideitInvitationCard, { IInvitationWithSms } from './RideitInvitationCard.vue';



@Component({
  components: {
    RideitInvitationCard,
  },
})
export default class RideitInvitationsDialog extends Vue {
  @Prop({ required: true}) private value: boolean;
  @Prop({ required: true }) private items: IInvitationWithSms[];
  @Prop({ required: true }) private passengerName: string;

  get dialogVisible() {
    return this.value;
  }
  set dialogVisible(newValue: boolean) {
    this.$emit('input', newValue);
  }

  get maxWidth() {
    return this.items.length > 1 ? '600px' : '300px';
  }

  

  closeDialog() {
    this.dialogVisible = false;
  }

}
